// <script type="text/javascript" src="//www.google.com/recaptcha/api/js/recaptcha_ajax.js"></script>
// import './../vendor/recaptcha_ajax';

window.$ = window.jQuery;


(function(jQuery){
    if (jQuery('.js-page-create-opinion').length > 0) {
        //Recaptcha.create("6LeQvykTAAAAAPDv5QUdKBUHrc__t9bQq-bSS3gU", 'captcha', {theme: 'white'});
    }
})(jQuery.noConflict());